import type { DiscountApplication } from '../../types/cartTypes';

/**
 * 计算折扣总金额（兜底验证用）
 * Store.total_discount 为权威，此函数仅用于防御性验证
 */
export function calculateDiscountSum(discounts: DiscountApplication[]): number {
    return discounts.reduce((sum, d) => sum + (d.total_allocated_amount || 0), 0);
}

/**
 * 验证折扣数据一致性（纯函数，返回结果）
 * Shopify 后端计算可能有舍入差异
 */
export function validateDiscountConsistency(
    storeTotal: number,
    discounts: DiscountApplication[]
): { isConsistent: boolean; diff: number } {
    const calculated = calculateDiscountSum(discounts);
    const diff = Math.abs(storeTotal - calculated);
    return {
        isConsistent: diff <= 1, // 容忍舍入误差
        diff
    };
}

/**
 * 检查是否有折扣
 */
export function hasAnyDiscount(totalDiscountCents: number): boolean {
    return totalDiscountCents > 0;
}
